export default () =>
  import(/* webpackChunkName: 'coffee/activities/red-packet' */ './RedPacket');
